module.exports = __webpack_public_path__ + "static/media/apartment_orange.59826c80.svg";